export default __webpack_public_path__ + "static/media/th-belga-rooftop-bar-sofitel-bangkok-sukhumvit.9b7e0f40.jpg";